<div class="container-fluid">
  <div class="row my-2 persona-name-section">
    <div class="col-6 pl-0">
      <nb-form-field>
        <input [ngModel]="name.value" (ngModelChange)="update('name', $event)" type="text" nbInput fullWidth shape="rectangle" placeholder="Title" />
        <!-- <mat-icon matTooltip="Choose a name for your persona. This name category will appear on the badge when printed." nbSuffix>help_outline</mat-icon> -->
      </nb-form-field>

      <!-- Protect Persona by passing a passcode toggle -->
      <nb-toggle class="mt-3" [(ngModel)]="isProtected" (change)="togglePasscode()">Protect registration form by a passcode</nb-toggle>
      <nb-form-field class="mt-3" *ngIf="isProtected">
        <input
          type="text"
          minlength="3"
          maxlength="8"
          required
          nbInput
          fullWidth
          shape="rectangle"
          placeholder="Set a passcode"
          [status]="pass_code.invalid && pass_code.touched ? 'danger' : 'basic'"
          [formControl]="pass_code"
        />
      </nb-form-field>
      <span class="d-inline-block mt-2 text-danger" *ngIf="pass_code.invalid && pass_code.touched && isProtected && pass_code.errors.required">Passcode is missing</span>
      <span class="d-inline-block mt-2 text-danger" *ngIf="pass_code.invalid && pass_code.touched && isProtected && pass_code.errors.minlength"
        >Passcode must be at least 3 characters</span
      >
    </div>
    <div class="col-6 pr-0">
      <nb-form-field>
        <input
          [ngxNumericOnly]="true"
          [ngModel]="maximum_registrations.value"
          (ngModelChange)="update('maximum_registrations', $event)"
          type="text"
          nbInput
          fullWidth
          shape="rectangle"
          placeholder="Maximum registrations e.g. 300"
        />
      </nb-form-field>
    </div>
  </div>
  <div class="row mt-5 section">
    <div class="col-12 p-0">
      <h6 class="text-left section-header d-flex m-0">
        Zone Access
        <!-- <mat-icon class="ml-3" matTooltip="Select the zones your persona should have access to during the event." matTooltipPosition="above"> help_outline </mat-icon> -->
      </h6>
      <div class="tags">
        <ngx-micetribe-tags
          [isCheckin]="true"
          [currentItems]="form.get('sub_locations_ids').value"
          [emptyTitle]="'No zones selected'"
          [noOptionsTitle]="'Setup your zones first'"
          [availableItems]="availableZones"
          (selectedItemsChanged)="updateAvailableZones($event)"
        >
        </ngx-micetribe-tags>
      </div>
    </div>
  </div>
  <ngx-personas-form-elements [eventLegalSetup]="eventLegalSetup" [formElements]="fields" [hasHandshake]="hasHandshake" [form]="form"></ngx-personas-form-elements>
  <app-confirmations-reminders
    [form]="form"
    [event]="event"
    [requireApproval]="require_approval"
    [message]="message"
    [regret]="regret"
    (previewConfirmation)="personaSave(false)"
  ></app-confirmations-reminders>

  <div class="row d-block mt-5 section">
    <div class="col-12 p-0">
      <div class="text-left section-header d-flex m-0 justify-content-between">
        <div class="d-flex w-100 justify-content-between">
          <h6>Ticket Price</h6>
          <nb-toggle
            class="ml-2"
            [ngModel]="enable_payment.value"
            [disabled]="!isStripeConnected || !hasPaymentGateway() || hasProducts"
            [matTooltip]="isStripeConnected && hasProducts ? 'Persona ticket sales cannot be enabled because ticketing is currently being managed by the marketplace.' : ''"
            (ngModelChange)="update('enable_payment', $event)"
            >This persona pays to attend</nb-toggle
          >
          <!-- <mat-icon class="ml-3" matTooltip="Messages & Info." matTooltipPosition="above"> help_outline </mat-icon> -->
        </div>
      </div>
    </div>
    <div class="col-12 pt-2 pb-3" *ngIf="enable_payment.value">
      <div class="my-2 d-flex"></div>
      <div class="payment-redirect-link" *ngIf="!isStripeConnected && isMainEntity">
        Connect your organization account with Stripe to collect payment, click <a class="link" (click)="navigateToOrganizerPage()">here</a>
      </div>
      <div class="payment-redirect-link" *ngIf="isStripeConnected && !hasPaymentGateway()">Connect your organization account with payment gateway from workspace settings</div>
      <div class="payment-redirect-link" *ngIf="!isStripeConnected && !isMainEntity">Contact your main workspace administrators to connect with Stripe</div>
      <div class="row mt-3 mr-0 ml-0" *ngIf="isStripeConnected && enable_payment.value">
        <div class="col-xl-3 col-lg-3 col-md-4 col-6 pl-0 m-0">
          <nb-form-field>
            <nb-select [ngModel]="currency_id.value" (ngModelChange)="update('currency_id', $event)" placeholder="Select payment currency" fullWidth>
              <nb-option *ngFor="let currency of currencyList" [value]="currency.id">
                {{ currency.name }}
              </nb-option>
            </nb-select>
          </nb-form-field>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-6 m-0 field-input">
          <div class="field d-flex">
            <nb-form-field>
              <input
                [ngModel]="form.controls['registration_amount'].value"
                (ngModelChange)="update('registration_amount', $event)"
                placeholder="e.g. 9.99"
                type="number"
                min="0"
                nbInput
                fullWidth
                shape="rectangle"
              />
            </nb-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="enable_payment.value">
      <h6 class="text-left d-flex m-0">Discount codes</h6>
      <div class="tags px-0">
        <ngx-micetribe-tags
          [listType]="'PromoCodes'"
          [eventId]="event.id"
          [currentItems]="form.get('promo_code_ids')?.value"
          [emptyTitle]="'No discount code selected'"
          [noOptionsTitle]="'Create a discount code first'"
          [availableItems]="promoCodes$ | async"
          (selectedItemsChanged)="updateSelectedPromoCodes($event)"
          [currency]="currencySlug()"
        >
        </ngx-micetribe-tags>
      </div>
    </div>
  </div>
  <!-- <div class="row">
        <div class="col-12 d-flex p-0">
            <button type="button" role="button" mat-raised-button color="primary" class="my-3 ml-auto" (click)="personaSave()">Save</button>
        </div>
    </div> -->
  <!-- <ngx-personas-handshake *ngIf="form.value.type !== 100 && isEnabled" [persona]="form" [personas]="personas"> </ngx-personas-handshake> -->
</div>

